module.exports = __webpack_public_path__ + "media/video.9f6afaf2.mp4";